// extracted by mini-css-extract-plugin
export default {"logo_container":"LogosSection_logo_container__YO65a"};